import unifydata from './interfaces/unifydata';
import note from './interfaces/note';
import card from './interfaces/card';
import passport from './interfaces/passport';
import tts from './interfaces/tts';
import online from './interfaces/online';
import digitalbook from './interfaces/digitalbook';
import other from './interfaces/other';

export default {
  unifydata,
  note,
  card,
  passport,
  tts,
  online,
  digitalbook,
  other
}